// src/store/instagramSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { isNullOrUndefined } from "../utils";

// Create an async thunk for fetching Instagram media
export const fetchInstagramMedia = createAsyncThunk(
  "instagram/fetchMedia",
  async ({ userId, accessToken, limit, paginatedUrl }) => {
    let url = paginatedUrl
      ? paginatedUrl
      : `https://graph.instagram.com/${userId}/media?fields=id,media_type,media_url,thumbnail_url&access_token=${accessToken}`;
    if (isNullOrUndefined(paginatedUrl) && limit) {
      url += `&limit=${limit}`;
    }

    const response = await axios.get(url);
    console.log(response.data);
    return response.data;
  }
);

export const fetchStories = createAsyncThunk(
  "instagram/fetchStories",
  async ({ userId, accessToken, limit, paginatedUrl }) => {
    let url = paginatedUrl
      ? paginatedUrl
      : `https://graph.instagram.com/${userId}/stories?fields=id,media_type,media_url,thumbnail_url&access_token=${accessToken}`;
    // if (isNullOrUndefined(paginatedUrl) && limit) {
    //   url += `&limit=${limit}`;
    // }

    const response = await axios.get(url);
    console.log(response.data);
    return response.data;
  }
);

const instagramSlice = createSlice({
  name: "instagram",
  initialState: {
    credentials: {},
    postsWithAutomations: [],
    posts: [],
    reels: [],
    stories: [],
    comments: {}, // { mediaId: [{ keyword, reply }] }
    loading: false,
    error: null,
    otherData: {},
  },
  reducers: {
    setInstagramAccountCredentials(state, action) {
      state.credentials = action.payload;
    },
    clientInstaPlan(state, action) {
      state.otherData.plan = action.payload;
    },
    saveKeywordReply(state, action) {
      const { mediaId, keyword, reply } = action.payload;
      if (!state.comments[mediaId]) {
        state.comments[mediaId] = [];
      }
      state.comments[mediaId].push({ keyword, reply });
    },
    clearComments(state, action) {
      delete state.comments[action.payload];
    },
    setStories(state, action) {
      const stories = action.payload;
      state.stories = stories;
    },
    clearPosts(state) {
      state.posts = [];
      state.reels = [];
      state.stories = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchInstagramMedia.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchInstagramMedia.fulfilled, (state, action) => {
        const newPosts = action.payload.data || [];
        const existingPostIds = new Set(state.posts.map((post) => post.id));
        state.otherData.nextPostsSet = action.payload?.paging?.next;
        // Filter out duplicates
        const uniquePosts = newPosts.filter(
          (post) => !existingPostIds.has(post.id)
        );

        state.posts.push(...uniquePosts);
        state.loading = false;
      })
      .addCase(fetchInstagramMedia.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchStories.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchStories.fulfilled, (state, action) => {
        console.log(action.payload);
        const newStories = action.payload.data || [];
        const existingPostIds = new Set(state.stories.map((story) => story.id));
        state.otherData.nextStoriesSet = action.payload?.paging?.next;
        // Filter out duplicates
        const uniqueStories = newStories.filter(
          (post) => !existingPostIds.has(post.id)
        );

        state.stories.push(...uniqueStories);
        state.loading = false;
      })
      .addCase(fetchStories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

// Export actions
export const {
  clientInstaPlan,
  saveKeywordReply,
  clearComments,
  setStories,
  clearPosts,
  setInstagramAccountCredentials,
} = instagramSlice.actions;

// Export the reducer
export default instagramSlice.reducer;
